/*
**  rui-sort-button.js
**
**  rui-sort-button component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
export class RuiSortButton extends LitElement {
    static get is() {
        return 'rui-sort-button';
    }
    static get properties() {
        return {
            text: { type: String },
            showArrow: { type: Object },
            arrowDirection: { type: String }
        };
    }
    constructor() {
        super();
        this.text = '';
        this.showArrow = false;
        this.arrowDirection = 'up';
    }
    click(e) {
        e.preventDefault();
        e.stopPropagation();
        let clickEvent = new CustomEvent('rui-click', {
            detail: {},
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(clickEvent);
    }
    render() {
        const iconClasses = {
            ['rui-sort-button-icon']: true,
            ['rui-sort-button-icon-up']: this.arrowDirection.toLowerCase() === 'up'
        };
        return html `
            <button class="rui-sort-button" @click="${this.click}">
                <div class="rui-sort-button-container">
                    <span class="rui-sort-button-text">${this.text}</span>
                    ${this.showArrow ? html `<rui-icon iconType="window-dropdown" context="sort-btn" aria-hidden="true" class="${classMap(iconClasses)}"></rui-icon>` : ''}
                </div>
            </button>
        `;
    }
    static get styles() {
        return css `
            .rui-sort-button {
                color: var(--accent, #287cc0);
                background: none;
                border: none;
                border-radius: var(--btn-border-radius, 1px);
                cursor: pointer;
                font-family: var(--font-family, "Segoe UI", "Open Sans", "Helvetica Neue", Arial, sans-serif);
                font-size: var(--btn-font-size-md, 14px);
                line-height: var(--btn-line-height-md, 1.42857143);
                font-weight: 600;
                outline-style: none;
                padding: 4px 0;
                user-select: none;
                -webkit-font-smoothing: antialiased;
            }
            
            .rui-sort-button:hover {
                background-color: var(--btn-secondary-bg-hover, #f2f2f5);
                border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
            }
            
            .rui-sort-button:focus {
                background-color: var(--btn-secondary-bg-hover, #f2f2f5);
                border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
                outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
                outline-offset: var(--outline-offset-btn, 0);
            }
            
            .rui-sort-button:active {
                background-color: var(--btn-secondary-bg-active, #d5d5df);
                border-color: var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
                outline: var(--outline-width, 1px) var(--outline-style, solid) var(--btn-secondary-border, rgba(56, 120, 171, 0.5));
                outline-offset: var(--outline-offset-btn, 0);
            }
            
            .rui-sort-button-container {
                display: flex;
            }
            
            .rui-sort-button-text {
                flex: 1 0 0%;
            }
            
            .rui-sort-button-icon {
                flex: 0 0 auto;
                margin-left: 6px;
            }
            
            .rui-sort-button-icon-up {
                transform: rotate(-180deg);
            }
       
            @media print {
                .rui-sort-button {
                    color: #000000;
                }
            }
        `;
    }
}
customElements.get(RuiSortButton.is) || customElements.define(RuiSortButton.is, RuiSortButton);
